import { gql } from '@apollo/client';

import {
  CreditFactorInquirySection,
  CreditFactorTradeline,
  CreditFactorTradelineOpenClosedSymbol,
  CreditHistoryPayStatusCode,
} from '@generated-gql/generated-types';

const PAY_STATUS_TO_COLOR_NAME = {
  [CreditHistoryPayStatusCode.Current]: 'green-light',
  [CreditHistoryPayStatusCode.Unknown]: 'neutral-darker',
  [CreditHistoryPayStatusCode.Late_30Days]: 'red-light',
  [CreditHistoryPayStatusCode.Late_60Days]: 'red',
  [CreditHistoryPayStatusCode.Late_90Days]: 'red-dark',
  [CreditHistoryPayStatusCode.Late_120Days]: 'red-darker',
  [CreditHistoryPayStatusCode.Late_150Days]: 'red-darker',
  [CreditHistoryPayStatusCode.CollectionChargeoff]: 'neutral-darkest',
  [CreditHistoryPayStatusCode.PaymentPlan]: 'neutral-darkest',
  [CreditHistoryPayStatusCode.Repossession]: 'neutral-darkest',
};

// Maps the CreditFactorTradeline.payStatus to an
// equivalent CreditHistoryPayStatusCode/CreditHistoryPayStatusNegativeCode
export const PAY_STATUS = {
  Current: CreditHistoryPayStatusCode.Current,
  Unknown: CreditHistoryPayStatusCode.Unknown,
  '30 Delinq': CreditHistoryPayStatusCode.Late_30Days,
  '60 Delinq': CreditHistoryPayStatusCode.Late_60Days,
  '90 Delinq': CreditHistoryPayStatusCode.Late_90Days,
  '120 Delinq': CreditHistoryPayStatusCode.Late_120Days,
  '150 Delinq': CreditHistoryPayStatusCode.Late_150Days,
  'Coll/Chargeoff': CreditHistoryPayStatusCode.CollectionChargeoff,
  WEP: CreditHistoryPayStatusCode.PaymentPlan,
  Repo: CreditHistoryPayStatusCode.Repossession,
};

export const CREDIT_SCORE_MIN = 300;
export const CREDIT_SCORE_MAX = 850;

export const isTradelineOpen = (tradeline: CreditFactorTradeline) =>
  tradeline.openClosedSymbol === CreditFactorTradelineOpenClosedSymbol.Open;
isTradelineOpen.fragment = gql`
  fragment isTradelineOpenFragment on CreditFactorTradeline {
    openClosedSymbol
  }
`;

export const getPrioritySectionsInquiriesLength = (
  sections: CreditFactorInquirySection[],
) => {
  const prioritySection = sections?.find((section) => section?.isPriority);
  return prioritySection?.inquiries?.length || 0;
};

export const getNonPrioritySectionsInquiriesLength = (
  sections: CreditFactorInquirySection[],
) => {
  const nonPrioritySections = sections?.filter(
    (section) => !section?.isPriority,
  );
  return nonPrioritySections.reduce(
    (acc, section) => acc + (section?.inquiries?.length || 0),
    0,
  );
};

export const mapPayStatusToColorName = (status: string) => {
  const statusKey = PAY_STATUS[status] || PAY_STATUS.Unknown;
  return PAY_STATUS_TO_COLOR_NAME[statusKey];
};
